module.exports = "/images/icon_32_close.png?5e6b5134d52877c06a13a7af63cd2116";